<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="10" viewBox="0 0 17 10" fill="none">
    <path
      d="M12.0271 8.95208L13.2271 7.75208L9.16042 3.68542L6.41875 6.42708C6.09375 6.75208 5.56875 6.75208 5.24375 6.42708L0.24375 1.41875C-0.08125 1.09375 -0.08125 0.56875 0.24375 0.24375C0.56875 -0.08125 1.09375 -0.08125 1.41875 0.24375L5.82708 4.66042L8.56875 1.91875C8.89375 1.59375 9.41875 1.59375 9.74375 1.91875L14.4021 6.56875L15.6021 5.36875C15.8604 5.11042 16.3104 5.29375 16.3104 5.66042V9.23542C16.3104 9.46875 16.1271 9.65208 15.8938 9.65208H12.3188C11.9521 9.66042 11.7688 9.21042 12.0271 8.95208Z"
      fill="#656C6F"
    />
  </svg>
</template>
